import {Grid} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import {DeleteButtonTextField} from "../DeleteButtonTextField/DeleteButtonTextField";
import React, { useEffect, useRef } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import { useDrag, useDrop } from "react-dnd";

const useStyles = makeStyles(() => ({
    numberField: {
        width: '47px'
    },
    fakeField: {
        width: '100%',
        minHeight: '40px',
        padding: '7px 14px',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '4px',
        '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.87)',
            cursor: 'pointer'
        }
    },

}))

export const FakeFieldTemplate = ({
                                      sequenceNumber,
                                      label,
                                      handleSequenceNumberChange,
                                      handleFieldTemplateDelete,
                                      handleFieldTemplateClick,
                                      moveField,
                                      index,
                                      ...fieldProps
                                  }) => {
    const classes = useStyles()

    const ref = useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: 'component',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId()
            }
        },
        hover: (item, monitor) => {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index  ;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) {
                return;
            }
            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset !==null && clientOffset.y - hoverBoundingRect.top;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            moveField(dragIndex, hoverIndex);
            item.index = hoverIndex;
        }
    })

    const [{ isDragging }, drag] = useDrag({
        type: 'component',
        item: () => ({ id: fieldProps.id, index }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const opacity = isDragging ? 0 : 1;

    useEffect(() => {
        drag(drop(ref));
    },[fieldProps])

    const preventDefault = (e) => e.preventDefault();

    return (
        <Grid 
            item 
            container 
            spacing={2} 
            style={{position: 'relative', opacity}}
            ref={ref}
            onDrop={preventDefault}
            data-handler-id={handlerId}
        >
            <Grid item>
                <TextField value={sequenceNumber}
                        className={classes.numberField}
                        variant={"outlined"}
                        size={"small"}
                />
            </Grid>
            <Grid item xs>
                <div className={classes.fakeField} onClick={handleFieldTemplateClick}>
                    <Typography variant={'body1'}>
                        {label.slice(0, 50)}
                    </Typography>
                </div>
                <DeleteButtonTextField onClick={handleFieldTemplateDelete} style={{
                    position: 'absolute',
                    top: '4px',
                    right: '4px'
                }}/>        
            </Grid>
        </Grid> 
    );
}